export default {
    parameters: {
        landing_id: "MxAuInt",
    },
    downtimeUrl: "https://cl.kodland.tech",
    startPage: {
      image: "/welcome/quiz_latam_internship_pk.png",
      imageMobile: "/welcome/quiz_latam_internship_mobile.png",
      title: "¡En lugar de jugar videojuegos y ver YouTube, nuestros niños están aprendiendo programación! 🔥",
      subtitle: "Tu hijo/a podrá participar en la clase que prefiera",
      button: "Comenzar 🚀",
    },
    successPage: {
      title: "Este es el último paso que necesitas tomar para obtener una clase gratuita de programación uno a uno con un tutor calificado para tu hijo/a 🚀",
      subtitle: "<b>Haz clic en '📆 Reservar una clase' para completar el registro 🔥</b> ¡Tu hijo/a desarrollará habilidades informáticas directamente desde la escuela, gracias a la experiencia práctica en pasantías y proyectos reales de ciencias de la computación!",
      button: "📆 Reservar una clase",
    },
    stopPage: {
      image: "/welcome/quiz_stop_page.jpg",
      title: "¡Gracias por confiar en nuestra plataforma educativa! Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras aulas la próxima vez!",
    },
    quizRotateBySteps: {
      1: {
        question:
          "¿Cuál es la asignatura favorita de tu hijo/a?",
        answers: [
            "🔬 Ciencias", 
            "🎨 Arte y diseño",
            "🖥 Computación / Informática",
            "📙 Humanidades (Historia, Literatura, etc.)",
            "🌐 Idiomas",
            "🔢 Matemáticas",
            "😍 A él(ella) le encantan todas las materias",
            "🤔 No estoy seguro(a)",
        ],
      },
      2: {
        question: "¿Por qué deberías estar interesado/a en aprender programación?",
        answers: [
          "🎮 Tu hijo/a juega muchos videojuegos",
          "😜 Tu hijo/a está “adicto/a” a YouTube y TikTok",
          "👾 El niño/a está interesado/a en la programación",
          "❓ Otro motivo",
        ],
      },
      3: {
        question:
          "Para tener una perspectiva, ¿a qué tipo de trabajo le encantaría dedicarse tu hijo/a en el futuro?",
        answers: [
          "📈 Trabajar con cálculos para TI, ingeniería o finanzas",
          "✍️ Escribir historias y realizar trabajos creativos",
          "💬 Crear algo nuevo, ser un innovador",
          "Otra opción",
        ],
      },
      4: {
        question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
        answers: [
          "💻 Sí",
          {
            answer: "😐 No",
            stopAnswer: true
          },
        ],
      },
    },
  };
  
  
